module.exports = __webpack_public_path__ + "assets/img/filter.active.6cf0f65f.svg";